import React from "react";
import Slider from "react-slick";
import styled from "styled-components";
import tw from "twin.macro";
import { css } from "styled-components/macro";
import { SectionHeading as HeadingTitle } from "../misc/Headings.js";
import Iframe from 'react-iframe';
import { useTranslation } from "react-i18next";

import "slick-carousel/slick/slick.css";

const Container = tw.div`relative bg-black text-white`;
const Content = tw.div`max-w-screen-xl mx-auto py-20 lg:py-24`;
const HeadingInfoContainer = tw.div`flex flex-col items-center`;
const HeadingDescription = tw.p`mt-4 font-medium text-gray-300 text-center max-w-sm`;

const TestimonialSliderContainer = tw.div`mt-24`;
const TestimonialSlider = styled(Slider)``;
const Testimonial = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row md:justify-center outline-none py-8 px-4`}
  background: linear-gradient(135deg, #1a1a1a, #000000);
  border: 1px solid #333;
  border-radius: 12px;
  box-shadow: 0 0 20px rgba(255, 0, 0, 0.2);
`;

const IframeContainer = styled.div`
  ${tw`md:mx-3 lg:mx-6 w-2/3 md:w-4/12 rounded flex items-center max-w-xs md:max-w-none`}
  iframe {
    ${tw`rounded`}
  }
`;

const Thumbnail = styled.img`
  ${tw`w-full rounded`}
`;

const TextContainer = tw.div`md:mx-3 lg:mx-6 md:w-6/12 py-4 flex flex-col justify-between`;
const ButtonContainer = tw.div`flex justify-center md:justify-start mt-4`;

const Button = styled.a`
  ${tw`mt-6 text-sm sm:text-base lg:text-sm xl:text-base px-8 py-3 rounded focus:outline-none transition duration-300`}
  background: radial-gradient(circle at center, #ff0000, #8b0000);
  color: #fff;
  border: 2px solid #660000;
  box-shadow: 0 0 10px rgba(255, 0, 0, 0.6), 0 0 20px rgba(255, 0, 0, 0.3);
  font-family: 'Orbitron', sans-serif;
  &:hover {
    background: #a30000;
    box-shadow: 0 0 15px rgba(255, 0, 0, 0.8);
  }
`;

const SliderControlButtonContainer = styled.div`
  ${tw`absolute top-0 h-full flex items-end md:items-center z-20`}
  button {
    ${tw`text-gray-500 hover:text-red-500 focus:outline-none transition duration-300 transform hover:scale-125 transform -translate-y-2/3 md:translate-y-0`}
  }
`;

const NextArrow = ({ currentSlide, slideCount, ...props }) => (
  <SliderControlButtonContainer tw="right-0">
    <button {...props}></button>
  </SliderControlButtonContainer>
);

const PreviousArrow = ({ currentSlide, slideCount, ...props }) => (
  <SliderControlButtonContainer tw="left-0">
    <button {...props}></button>
  </SliderControlButtonContainer>
);

const LinktreeContainer = tw.div`flex justify-center mt-16`;

const LinktreeButton = styled.a`
  ${tw`px-12 py-4 text-xl font-bold rounded transition duration-300`}
  background: linear-gradient(to right, #ff0000, #8b0000);
  color: #fff;
  border: 2px solid #660000;
  font-family: 'Orbitron', sans-serif;
  box-shadow: 0 0 12px rgba(255, 0, 0, 0.4);
  &:hover {
    background: #a30000;
    box-shadow: 0 0 20px rgba(255, 0, 0, 0.6);
  }
`;

// Utilidades
const extractVideoId = (url) => {
  const match = url.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/);
  return match ? match[1] : "";
};

const isYouTubeUrl = (url) => {
  return url.includes("youtube.com") || url.includes("youtu.be");
};

export default () => {
  const { t } = useTranslation();
  const testimonials = t("sets.items", { returnObjects: true }); // YA NO cortamos con slice(1)

  return (
    <Container>
      <Content>
        <HeadingInfoContainer>
          <HeadingTitle>{t("sets.title")}</HeadingTitle>
          <HeadingDescription>{t("sets.description")}</HeadingDescription>
        </HeadingInfoContainer>

        <TestimonialSliderContainer>
          <TestimonialSlider nextArrow={<NextArrow />} prevArrow={<PreviousArrow />}>
            {testimonials.map((testimonial, index) => (
              <Testimonial key={index}>
                <IframeContainer>
                  {isYouTubeUrl(testimonial.url) ? (
                    <Thumbnail
                      src={`https://img.youtube.com/vi/${extractVideoId(testimonial.url)}/hqdefault.jpg`}
                      alt={testimonial.title}
                    />
                  ) : (
                    <Iframe
                      url={testimonial.url}
                      width="100%"
                      height="200px"
                      display="initial"
                      position="relative"
                      allowFullScreen
                    />
                  )}
                </IframeContainer>
                <TextContainer>
                  <h3 tw="text-lg font-semibold">{testimonial.title}</h3>
                  <ButtonContainer>
                    <Button href={testimonial.url} target="_blank">{t("sets.button")}</Button>
                  </ButtonContainer>
                </TextContainer>
              </Testimonial>
            ))}
          </TestimonialSlider>
        </TestimonialSliderContainer>

        <LinktreeContainer>
          <LinktreeButton href="https://linktr.ee/rafaeldiyei" target="_blank">
            {t("sets.linktree")}
          </LinktreeButton>
        </LinktreeContainer>
      </Content>
    </Container>
  );
};
